import dynamic from 'next/dynamic'

export const MultiImageSection = dynamic(() => import('./multi-image-section'))
